export default function () {
  let wait = false;
  const popup = document.querySelector('.popup');
  const close = document.querySelector('.popup__close');
  let popupClosed = false;

  if (!popup) return;

  document.addEventListener('scroll', function() {
    if (wait) return;

    if (window.scrollY > document.documentElement.offsetHeight / 2) {
      popup.classList.remove('shown');
    } else {
      if (popupClosed) return;
      popup.classList.add('shown');
    }

    wait = true;

    setTimeout(function () {
      wait = false;
    }, 300);
  });

  setTimeout(() => {
    popup.classList.add('shown');
  }, 3000);

  close.addEventListener('click', function(event) {
    event.preventDefault();
    popup.classList.remove('shown');
    popupClosed = true;
  });
}
